import type { KeyboardEvent } from 'react';
import type { ResolvedColumn } from '../../domain';
import type { Option } from './types';
import { chipValue } from './utils';

export interface ValueDropdownProps<T, O extends Option> {
    options: O[];
    column?: ResolvedColumn<T>;
    onSelect: (option: O) => void;
    onKeyDown: (
        e: KeyboardEvent<HTMLButtonElement>,
        activate: () => void,
    ) => void;
}

export function ValueDropdown<T, O extends Option>(
    props: ValueDropdownProps<T, O>,
): JSX.Element {
    const { options, column, onSelect, onKeyDown } = props;
    return (
        <div className="ics-table__search-dropdown" role="listbox">
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    role="option"
                    aria-selected={false}
                    className="ics-table__search-dropdown-item"
                    onClick={() => {
                        onSelect(option);
                    }}
                    onKeyDown={(e) => {
                        onKeyDown(e, () => {
                            onSelect(option);
                        });
                    }}
                >
                    {column ? chipValue(column, option.value) : option.label}
                </button>
            ))}
        </div>
    );
}
